module.exports = __webpack_public_path__ + "img/happy_product_item-1.6f630929.png";